import type { MemberLifecycleStage } from "@community-analytics/shared";

import { cn } from "@shared/lib";

import { stageStyle } from "../lib/stage-colors";

export interface StageBadgeProps {
  stage: MemberLifecycleStage;
  /** Externalized label — caller provides "NEW" / "Активный" / etc. */
  label: string;
  className?: string;
}

export function StageBadge({ stage, label, className }: StageBadgeProps) {
  const style = stageStyle(stage);
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-medium uppercase tracking-wide",
        style.backgroundClass,
        style.textClass,
        style.borderClass,
        className,
      )}
      data-stage={stage}
    >
      {label}
    </span>
  );
}
